import {ServiceClass} from '@/decorators';
import {InspepctionFormModel} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class InspectionFormsApi extends BaseApi {
    public async getInspectionFormsAsync(filter?: any) {
        return await this.GET_RequestAsync<Array<InspepctionFormModel>>(`${this.ApiUrl}/inspection-forms?filter=${encodeURIComponent(JSON.stringify(filter))}`);
    }

    public async getInspectionFormByIdAsync(id: string) {
        return await this.GET_RequestAsync<InspepctionFormModel>(`${this.ApiUrl}/inspection-forms/${id}`);
    }

    public async cloneInspectionForm(data: {inspectionFormId: string; title: string}) {
        return await this.POST_RequestAsync<InspepctionFormModel>(`${this.ApiUrl}/inspection-forms/clone`, data);
    }

    public async inspectionFormSettings(
        id: string,
        data: {protectionTechniqueGasIds: Array<string>; protectionTechniqueDustIds: Array<string>; title: string}
    ) {
        return await this.POST_RequestAsync<InspepctionFormModel>(`${this.ApiUrl}/inspection-forms/${id}/settings`, data);
    }
}
